import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';
import platform from 'platform';

class DeviceService {
    static trackDevice = (info) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        let deviceId = localStorage.getItem('deviceId');
        if (!deviceId) {
            let prefix = 'Dev';
            const currentPlatform = platform.os.toString().toLowerCase();
            if (currentPlatform.indexOf('windows') !== -1) {
                prefix = 'Win';
            } else if (currentPlatform.indexOf('os x') !== -1) {
                prefix = 'Mac';
            } else if (currentPlatform.indexOf('ios') !== -1) {
                prefix = 'iOS';
            } else if (currentPlatform.indexOf('android') !== -1) {
                prefix = 'Android';
            } else if (
                currentPlatform.indexOf('ubuntu') !== -1 ||
                currentPlatform.indexOf('debian') !== -1 ||
                currentPlatform.indexOf('fedora') !== -1 ||
                currentPlatform.indexOf('red hat') !== -1 ||
                currentPlatform.indexOf('redhat') !== -1 ||
                currentPlatform.indexOf('suse') !== -1 ||
                currentPlatform.indexOf('centos') !== -1 ||
                currentPlatform.indexOf('cent os') !== -1
            ) {
                prefix = 'Linux';
            }
            deviceId = `${prefix}-${new Date().getTime()}`;
            localStorage.setItem('deviceId', deviceId);
        }

        return fetchAPI({
            token,
            url: `${config.DeviceService}device/${platformId}`,
            method: 'PUT',
            parseJSON: false,
            body: {
                deviceId,
                info,
            },
        });
    };
}

export default DeviceService;
